"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const react_intl_1 = require("react-intl");
const table_cells_1 = require("../../../composite/table/table-cells");
const table_filter_cells_1 = require("../../../composite/table/table-filter-cells");
const export_api_1 = require("../export-api");
function useColumns() {
    const intl = react_intl_1.useIntl();
    return [
        {
            datakey: 'label',
            name: intl.formatMessage({
                id: 'EAS_EXPORT_TEMPLATES_COLUMN_LABEL',
                defaultMessage: 'Označení',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'dataProvider',
            sortkey: 'dataProvider.name',
            filterkey: 'dataProvider.id',
            name: intl.formatMessage({
                id: 'EAS_EXPORT_TEMPLATES_COLUMN_DATA_PROVIDER',
                defaultMessage: 'Zdroj dat',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            FilterComponent: table_filter_cells_1.TableFilterCells.useFilterSelectCellFactory(export_api_1.useExportDataProviders),
            valueMapper: table_cells_1.TableCells.useSelectCellFactory(export_api_1.useExportDataProviders),
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'designProvider',
            sortkey: 'designProvider.name',
            filterkey: 'designProvider.id',
            name: intl.formatMessage({
                id: 'EAS_EXPORT_TEMPLATES_COLUMN_DESIGN_PROVIDER',
                defaultMessage: 'Zdroj designu',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            FilterComponent: table_filter_cells_1.TableFilterCells.useFilterSelectCellFactory(export_api_1.useExportDesignProviders),
            valueMapper: table_cells_1.TableCells.useSelectCellFactory(export_api_1.useExportDesignProviders),
            sortable: true,
            filterable: true,
        },
    ];
}
exports.useColumns = useColumns;
//# sourceMappingURL=export-templates-colums.js.map